module.exports = __webpack_public_path__ + "img/DE05922.2f280165.png";